<template>
  <div id="kontakt-und-termin" class="mx-auto mt3 clearfix contact">
    <div class="max-width-4 mt3 mb3 mx-auto content-wrapper clearfix">
      <div class="md-col-8 sm-col-12 pr1 mx-auto clearfix">
        <div class="col-12">
          <h2 class="h3 headline mt0">Terminvereinbarung & Detailinformationen</h2>
          <div class="clearfix mt3">
            <div class="sm-col sm-col-12 md-col-6">
              <ul class="small list-style-none list-reset">
                <li class="p0 pb1">
                  <a href="tel:+43 6507537961" title="+43 6507537961" target="_self">
                    <font-awesome-icon icon="phone"/>
                    <span>+43 650 7537 961</span> </a>
                </li>
                <li class="p0 mt2 pb1">
                  <a href="mailto:harald.parr@gmx.at" title="harald.parr@gmx.at" target="_self">
                    <font-awesome-icon icon="envelope"/>
                    <span>harald.parr@gmx.at</span> </a>
                </li>
                <li class="p0 mt2 pb1">
                  <a href="https://goo.gl/maps/DXRJEyp6fDgFeiPX9" rel="noopener noreferrer" title="Grabenweg 68/15, 6020 Innsbruck" target="_blank">
                    <font-awesome-icon icon="map-marker"/>
                    <span>Grabenweg 68/15, 6020 Innsbruck</span> </a>
                </li>
              </ul>
            </div>
            <div class="sm-col sm-col-12 md-col-6">
              <p class="small">Kontaktieren sie mich telefonisch oder per e-mail. Sollte ich gerade
                nicht erreichbar sein, sprechen sie mir bitte auf die mail-box, ich rufe sie
                verlässlich zurück.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'app-contact'
}
</script>

<style scoped lang="scss">
@import "../assets/scss/variables";

$background-color: #f4f6f7;

.contact {
  padding-top: 1rem;
  padding-bottom: 1rem;
  background-color: $background-color;

  .headline {
    font-size: 1.5rem;
    line-height: 2rem;
    font-weight: bold;
    font-family: $headline-font;
    color: $primary-link-color;
    padding-top: 0.4rem;
    padding-bottom: 0.4rem;
    display: inline-block;
  }

  .small {
    font-size: 0.8rem;
    color: $secondary-link-color;
  }

  ul {
    li {
      font-size: 0.8rem;
      line-height: 1rem;
      color: $secondary-link-color;

      a {
        box-shadow: none;
        padding-bottom: 0.3rem;
        box-sizing: border-box;
        border-bottom: 1px solid transparent;

        span {
          padding-left: 0.3rem;
        }

        &:active,
        &:focus,
        &:hover {
          border-color: $secondary-link-color;
        }

      }

      .image {
        max-width: 8rem;
        height: auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue